import { IGenericCmsPage } from "api/interfaces/static-pages/common.type";
import Element from "component/design-system/react-scroll/components/Element";
import StoresLocation from "container/in-store-pickup/stores-location.component";
import { useTranslation } from "next-i18next";
import { memo, useState } from "react";
import { renderHTML } from "util/DomHelper";
import LandingPageBanner from "../../component/landing-page/LandingPageBanner";
import PageContainer from "../../modules/components/PageContainer";
import ContentIdsComponent from "../../modules/static-pages/content-ids/contentIds";
import { getRelativeImagePath } from "../../util/helper/getRelativeImagePath";
import { scrollTo } from "../../util/scroll-helper";
import { STORESMORELOCATIONS } from "./constant";
import ContactUsVertical from "./contactUsVertical";
import styles from "./in_store_pickup.module.scss";

const scrolEl = "stores_location";

function InstorePickup(props: IGenericCmsPage) {
  const response = props.actualResponse.landingPage;
  const { headers } = response;
  const { contentIds } = response.links;
  const pickupSteps = contentIds && contentIds
    .find((eachContent: any) => ["in-store-pickup-steps", "fr-in-store-pickup-steps"].includes(eachContent.url))?.uiDetails.content;
  const pickupFaqs = contentIds && contentIds
    .find((eachContent: any) => ["in-store-pickup-faqs", "fr-in-store-pickup-faqs"].includes(eachContent.url));
  const pickupLocations = contentIds && contentIds
    .find((eachContent: any) => ["pickup-locations", "fr-pickup-locations"].includes(eachContent.url))?.uiDetails.content;
  const { t } = useTranslation("static-pages");
  const [seeMoreStores, setSeeMoreStores] = useState(
    t("See More Stores Coming Soon"),
  );
  const [showMoreStores, setShowMoreStores] = useState(false);

  function onShowMoreStores() {
    setShowMoreStores((_expanded: any) => {
      if (_expanded) {
        scrollTo(scrolEl, {
          duration: 500,
          delay: 50,
          smooth: true,
          offset: -130,
        });
        setSeeMoreStores("See More Stores Coming Soon");
      } else {
        setSeeMoreStores("Show Less");
      }
      return !_expanded;
    });
  }

  return (
    <PageContainer>

      <LandingPageBanner
        className="m-t-10"
        style={{ height: "auto" }}
        bannerImages={{
          mobileImage: getRelativeImagePath("/banners/mobile/in-store-pickup.jpg"),
          desktopImage: getRelativeImagePath("/banners/in-store-pickup.jpg"),
        }}
        {...{ width: 1340, height: 256 }}
        alt="in store pickup"
      />

      {/* will add back once new video is avaliable */}
      {/* <VideoSection>
         <span className="heading text-center">See How it Works</span>
          <EmbedVideo videoSrc="https://www.youtube.com/embed/iFyvBDqQ9Qs?wmode=transparent&rel=0&showinfo=0&fs=1&autoplay=1" />
        </VideoSection> */}

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          paddingTop: "calc(3 * var(--safari-root-font, 10px))",
          flexDirection: "column",
          textAlign: "center",
        }}
      >

        <span className={`${styles.heading} text-center`}>{t("Click & Collect")}</span>

        <span className={`${styles.heading} text-center`} style={{ fontWeight: "100", color: "#555" }}>{headers.h1}</span>
      </div>

      <div className="row steps" style={{ paddingTop: "calc(4 * var(--safari-root-font, 10px))" }}>

        {pickupSteps.map((step: any) => (
          <div key={step.title} className={`col-sm-4 ${styles.mb_1}`}>

            <div
              className="d-flex flex-column"
              style={{ alignItems: "center" }}
            >

              <div className={styles.heading_icon}>

                <div
                  style={{
                    background: `url(${process.env.NEXT_PUBLIC_ROOT_URL}/images/home/partsavatar-title-icons.png)`,
                  }}
                  className={`${step.iconClass}`}
                />

                <span
                  className={`${styles.heading} ${styles.blue_color}`}
                  style={{ fontSize: "calc(2 * var(--safari-root-font, 10px))", textAlign: "center" }}
                >
                  {step.title}
                </span>
              </div>

              <hr style={{ width: "25%", border: "calc(0.1 * var(--safari-root-font, 10px)) solid #efefef" }} />
            </div>

            <ul style={{ width: "80%", margin: "calc(0 * var(--safari-root-font, 10px)) auto 3rem" }}>

              {step.steps.map((each: any) => (
                <li key={each} style={{ paddingBottom: "calc(1 * var(--safari-root-font, 10px))" }}>
                  <div dangerouslySetInnerHTML={renderHTML(each)} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="row faq-section">

        <div className={`col-11 col-sm-4 ${styles.mb_1} ${styles.sticky_faq}`}>

          <ContactUsVertical />
        </div>

        <div className={`col-11 col-sm-8 ${styles.mb_1}`}>

          {/* <span className={styles.heading} style={{ marginBottom: "calc(1 * var(--safari-root-font, 10px))" }}>
            {t("Frequently Asked Questions")}
          </span> */}

          <div
            className="accordion-section"
            style={{ marginTop: "calc(2 * var(--safari-root-font, 10px))", marginBottom: "calc(2 * var(--safari-root-font, 10px))" }}
          >
            <ContentIdsComponent contentIds={[pickupFaqs]} />

          </div>
        </div>
      </div>

      <div className="row stores">

        <Element name={scrolEl} />

        <div className="col-12 col-sm-12">

          <div className="d-flex" style={{ flexWrap: "wrap" }}>

            <span className={styles.heading}>{t("Find your nearest store")}</span>

            <img
              alt=""
              className={`canada-map img-responsive ${styles.mt_2} ${styles.mb_2}`}
              style={{ display: "inline-block" }}
              src={`${process.env.NEXT_PUBLIC_ROOT_URL}/cms/pubicImages/images/Store-Maps.webp`}
            />
          </div>

          <div
            className="text-center"
            style={{ marginTop: "calc(1 * var(--safari-root-font, 10px))", backgroundColor: "#fafafa" }}
          >

            <div className={`d-flex justify-content-around flex-wrap ${styles.locationContainer}`}>

              <div className="section-seperator" />

              <StoresLocation pickupLocations={pickupLocations} />

              <div className="section-seperator" />

            </div>

            {showMoreStores && (
              <div
                className="row d-flex flex-column"
                style={{ padding: "calc(3 * var(--safari-root-font, 10px))", textAlign: "left" }}
              >

                <span className={`${styles.heading} col-11 col-sm-11`}>
                  More Pick-Up, Returns & Delivery Coming Soon! Stay Tuned
                </span>

                <hr />
                {STORESMORELOCATIONS.map((store: any) => (
                  <div
                    key={store.stateName}
                    className={`${styles.each_store_location} col-11 col-sm-11`}
                  >

                    <div className={`${styles.heading} ${styles.mb_1} ${styles.light_grey_color}`}>
                      {store.stateName}
                    </div>

                    <div className={`${styles.subheading} row ${styles.light_grey_color}`}>
                      {store.cities.map((city: any) => (
                        <span key={city} className="col-sm-4">
                          {city}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div
              className="row d-flex"
              style={{ justifyContent: "center", marginBottom: "calc(2 * var(--safari-root-font, 10px))" }}
            >

              <div className={`col-sm-5 col-11 ${styles.mt_2} ${styles.mb_2}`}>

                <button
                  type="button"
                  className="btn btn-info text-bold background-blue store-button"
                  onClick={onShowMoreStores}
                >
                  {seeMoreStores}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}

export default memo(InstorePickup);
